import { FC } from 'react';
import {
  CreateButton,
  Datagrid,
  EditButton,
  List,
  ReferenceField,
  TextField,
  TopToolbar,
} from 'react-admin';

const ListActions = () => (
  <TopToolbar>
    <CreateButton label="Добавить продукт" />
  </TopToolbar>
);

export const ProductList: FC = () => (
  <List title="Список продуктов" filter={{}} actions={<ListActions />}>
    <Datagrid rowClick="edit">
      <TextField source="id" label="ID" />
      {/* <TextField source="feed_id" label="ID" /> */}
      <TextField source="name" label="Название" />
      <TextField source="type" label="Тип" />
      <TextField source="price" label="Цена" />
      <EditButton label="Редактировать" />
    </Datagrid>
  </List>
);
